import React, { useMemo } from 'react';
import range from 'lodash/range';
import gridStyle from './GridRow.scss';
const VisibleGridRow = ({ start , end , elementWidth , elementHeight , elementSpacing , withShadowSpace =true , renderElement  })=>{
    const inlineStyles = useMemo(()=>{
        const rowWidth = (elementWidth + elementSpacing) * (end - start) - elementSpacing;
        const styles = {
            width: rowWidth,
            ['containIntrinsicSize']: `${rowWidth}px ${elementHeight}px`,
            ['contentVisibility']: 'auto'
        };
        // create space around contents for shadows, ribbons, etc.
        // but draw it back in with negative margin so bounds match width
        if (withShadowSpace) {
            styles.margin = `-${elementSpacing}px`;
            styles.padding = `${elementSpacing}px`;
        } else if (start > 0) {
            // gap between rows
            styles.marginTop = `${elementSpacing}px`;
        }
        return styles;
    }, [
        elementHeight,
        elementSpacing,
        elementWidth,
        end,
        start,
        withShadowSpace
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: gridStyle['row'],
        style: inlineStyles
    }, range(start, end).map((index)=>renderElement({
            width: elementWidth,
            height: elementHeight,
            index,
            style: {
                width: elementWidth,
                height: elementHeight,
                marginLeft: index > start ? elementSpacing : 0
            },
            onscreen: true,
            visible: true
        })));
};
VisibleGridRow.displayName = 'VisibleGridRow';
export default VisibleGridRow;
